import { render, staticRenderFns } from "./LiquiditySection.vue?vue&type=template&id=012f8c85"
import script from "./LiquiditySection.vue?vue&type=script&lang=js"
export * from "./LiquiditySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports